import { render, staticRenderFns } from "./TableAndGraphCard.vue?vue&type=template&id=913a8e1c&scoped=true"
import script from "./TableAndGraphCard.vue?vue&type=script&lang=js"
export * from "./TableAndGraphCard.vue?vue&type=script&lang=js"
import style0 from "./TableAndGraphCard.vue?vue&type=style&index=0&id=913a8e1c&prod&scoped=true&lang=scss"
import style1 from "./TableAndGraphCard.vue?vue&type=style&index=1&id=913a8e1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913a8e1c",
  null
  
)

export default component.exports